/* eslint-disable max-len */
import React from 'react';

const BmoNavIcon: React.FC = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="3" y="2" width="18" height="20" rx="1" fill="white" stroke="#001B74" strokeWidth="1.3"/>
			<path d="M5 6.25H16" stroke="#001B74" strokeWidth="1.5"/>
			<path d="M5 10.25H13.5" stroke="#001B74" strokeWidth="1.5"/>
			<line x1="5" y1="14.25" x2="12" y2="14.25" stroke="#001B74" strokeWidth="1.5"/>
			<circle cx="19.5" cy="20.5" r="3.5" fill="#001B74"/>
			<line x1="17.5" y1="20.5" x2="21.5" y2="20.5" stroke="white" strokeLinecap="round"/>
			<line x1="19.5" y1="18.5" x2="19.5" y2="22.5" stroke="white" strokeLinecap="round"/>
			{/* customPath: keep the pencil dark on the white page when the nav item is active (MainNav styles force other paths white) */}
			<path className="customPath" fillRule="evenodd" clipRule="evenodd" d="M18.9336 3.59264C18.4562 2.80948 17.6484 2.80142 17.1644 3.57498L13.2451 9.83935C13.1198 10.0396 13.0252 10.28 12.968 10.5433L12 15L14.8463 14.272C15.0969 14.2079 15.3281 14.0252 15.5077 13.7496L19.643 7.40322C20.1078 6.68992 20.1203 5.53948 19.6713 4.80282L18.9336 3.59264ZM17.7505 4.43862C17.9118 4.18077 18.1811 4.18345 18.3402 4.44451L19.0779 5.65469C19.2276 5.90024 19.2234 6.28372 19.0685 6.52149L15.6053 11.8363L14.2787 9.98777L17.7505 4.43862ZM13.7419 10.9241C13.7408 10.9286 13.7398 10.9331 13.7388 10.9377L13.1976 13.4295L14.7127 13.042C14.7962 13.0206 14.8733 12.9597 14.9332 12.8678L15.0301 12.7191L13.7419 10.9241Z" fill="#001B74"/>
		</svg>
	);
};

export default BmoNavIcon;
